module.exports = __webpack_public_path__ + "img/img23.c8af1cd7.svg";